import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ページ URL 中の `?hoge=fuga&foo=bar` を取り出せるようにする
 */
const useQueryParams = (): URLSearchParams => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export { useQueryParams };
